import type { Page } from './Layout';
import styles from './Sidebar.module.css';

const ChartIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M18 20V10M12 20V4M6 20v-6" />
  </svg>
);

const PlayIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polygon points="5 3 19 12 5 21 5 3" />
  </svg>
);

const PencilIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const BuildingIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M3 21h18M9 8h1M9 12h1M9 16h1M14 8h1M14 12h1M14 16h1" />
    <path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16" />
  </svg>
);

interface SidebarProps {
  currentPage: Page;
  onNavigate: (page: Page) => void;
}

export function Sidebar({ currentPage, onNavigate }: SidebarProps) {
  return (
    <aside className={styles.sidebar}>
      <nav className={styles.nav}>
        <button
          className={`${styles.navItem} ${currentPage === 'progress' ? styles.active : ''}`}
          onClick={() => onNavigate('progress')}
        >
          <ChartIcon />
          <span>Progress</span>
        </button>

        <button
          className={`${styles.navItem} ${currentPage === 'start-quiz' ? styles.active : ''}`}
          onClick={() => onNavigate('start-quiz')}
        >
          <PlayIcon />
          <span>Start Quiz</span>
        </button>

        <button
          className={`${styles.navItem} ${currentPage === 'authoring' ? styles.active : ''}`}
          onClick={() => onNavigate('authoring')}
        >
          <PencilIcon />
          <span>Authoring</span>
        </button>

        <button
          className={`${styles.navItem} ${currentPage === 'corporate' ? styles.active : ''}`}
          onClick={() => onNavigate('corporate')}
        >
          <BuildingIcon />
          <span>Corporate</span>
        </button>
      </nav>
    </aside>
  );
}
